import "./AddLinkedinAccountModal.scss"

import { Stepper, TabBar } from "@skylead/component-library"
import React from "react"
import { useDispatch, useSelector } from "react-redux"

import { updateFormField } from "../../../redux/actions"
import { useGlobalTranslation } from "../../../utils/hook"

const AddLinkedinAccountModal = ({ activeStep = 0, showTabItems = false }) => {
  const dispatch = useDispatch()
  const { tt } = useGlobalTranslation()

  const [formData] = useSelector(state => [state.forms.formData])
  const { showDefaultProxies } = formData

  const handleDefaultProxies = async eventKey => {
    dispatch(updateFormField("showDefaultProxies", eventKey === "1"))
  }

  const tabBarItems = [
    {
      canView: true,
      label: tt("available-proxies"),
      isActive: showDefaultProxies,
      onClick: () => handleDefaultProxies("1"),
    },
    {
      canView: true,
      label: tt("custom-proxy"),
      isActive: !showDefaultProxies,
      onClick: () => handleDefaultProxies("2"),
    },
  ]

  return (
    <div className="add-linkedin-modal">
      <Stepper
        steps={[
          { label: tt("proxy"), icon: "world-20" },
          { label: tt("account-info"), icon: "info-circle-20" },
        ]}
        activeStep={activeStep}
        isOverlay
      />
      {showTabItems && <TabBar items={tabBarItems} />}
    </div>
  )
}

// AddLinkedinAccountModal.propTypes = {
//   activeStep: PropTypes.number,
//   showTabItems: PropTypes.bool,
// }

export default AddLinkedinAccountModal
